import { render, staticRenderFns } from "./addCompany.vue?vue&type=template&id=00a4bf0c&scoped=true&"
import script from "./addCompany.vue?vue&type=script&lang=js&"
export * from "./addCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4bf0c",
  null
  
)

export default component.exports